// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__up6Bm","title":"Header_title__3vz_T","side":"Header_side__2KLbZ"};